import { defineMessages } from 'react-intl';

export const SIGN_IN_GA_CATEGORY = 'Sign In';
export const GaActionText = {
    trackEmailFieldSelect: 'Email Field Select',
    trackPasswordFieldSelect: 'Password Field Select',
    trackRememberMeChange: 'Remember Me Change',
    trackClickForgotPassword: 'Click Forgot Password',
    trackClickResetPassword: 'Click Reset Password',
    trackClickContinue: 'Click Continue',
    trackClickFacebookLogin: 'Click Facebook Login',
    trackClickGoogleLogin: 'Click Google Login',
    trackClickCreateAccount: 'Click Create Account',
};
export const PATIENT_MODE = 'patient';
export const PROVIDER_MODE = 'provider';

export const LOCALIZED_STRINGS = defineMessages({
    AccountLocked: {
        id: 'Components.SignInForm.Error.SorryAccountLocked',
        defaultMessage: 'Sorry, this account has been locked.',
    },
    BlankEmail: {
        id: 'Components.SigninForm.Error.InvalidEmail',
        defaultMessage: 'Please type an email.',
    },
    BlankPassword: {
        id: 'Components.SigninForm.Error.InvalidPassword',
        defaultMessage: 'Please type your password.',
    },
    CreateAnAccount: {
        id: 'SignIn.CreateAnAccount',
        defaultMessage: 'Sign up with email',
    },
    EmailLabel: {
        id: 'Components.SignInForm.EmailFieldLabel',
        defaultMessage: 'Email',
    },
    EmailPlaceholder: {
        id: 'Components.SignInForm.EmailAddress',
        defaultMessage: 'email address',
    },
    ForgotPassword: {
        id: 'Components.SignInForm.ForgotYourPassword',
        defaultMessage: 'Forgot your password?',
    },
    IncorrectEmailOrPassword: {
        id: 'Components.SignInForm.Error.IncorrectEmailOrPassword',
        defaultMessage: 'Incorrect email or password.',
    },
    InvalidEmail: {
        id: 'Components.SigninForm.Error.InvalidEmail.Valid',
        defaultMessage: 'Please type a valid email.',
    },
    PasswordLabel: {
        id: 'Components.SignInForm.PasswordFieldLabel',
        defaultMessage: 'Password',
    },
    PasswordPlaceholder: {
        id: 'Components.SignInForm.Password',
        defaultMessage: 'password',
    },
    PatientLogin: {
        id: 'Components.SignInFormPatientProviderMode.PatientLogin',
        defaultMessage: 'Patient login',
    },
    ProviderLogin: {
        id: 'Components.SignInFormPatientProviderMode.ProviderLogin',
        defaultMessage: 'Provider login',
    },
    RememberMe: {
        id: 'Components.SignInForm.RememberMeCheckboxLabel',
        defaultMessage: 'Keep me signed in',
    },
    ResetPassword: {
        id: 'Components.SignInForm.ResetPassword',
        defaultMessage: 'Please reset your password.',
    },
    SignIn: {
        id: 'Components.SignInForm.SignIn',
        defaultMessage: 'Log in',
    },
    SignInHeader: {
        id: 'Components.SignInForm.SignIntoYourZocdocAccount',
        defaultMessage: 'Sign in to your Zocdoc account',
    },
    SocialLoginGoogleOnlyNonPatient: {
        id: 'Components.SigninForm.Error.SocialLoginGoogleOnlyNonPatient',
        defaultMessage: 'Only patients can log in with Google. Please log in with your email instead.',
    },
    SocialLoginFacebookAndGoogleNonPatient: {
        id: 'Components.SigninForm.Error.SocialLoginFacebookAndGoogleNonPatient',
        defaultMessage: 'Only patients can log in with Facebook or Google. Please log in with your email instead.',
    },
    SomethingWentWrong: {
        id: 'Components.SigninForm.Error.SomethingWentWrong',
        defaultMessage: 'Something went wrong...',
    },
    StandardLoginDividerText: {
        id: 'SignIn.StandardLoginDividerText',
        defaultMessage: 'or',
    },
    StandardLoginTitle: {
        id: 'SignIn.StandardLoginTitle',
        defaultMessage: 'Log in with email',
    },
    TryAgain: {
        id: 'Components.SigninForm.Error.TryAgain',
        defaultMessage: 'Something went wrong, please try again...',
    },
    UserLocked: {
        id: 'Components.SignInForm.UserLocked',
        defaultMessage: 'You\'ve attempted to log in too many times.',
    },
});

export const LOGIN_TYPE = {
    google: 'google',
    facebook: 'facebook',
};
